export default __webpack_public_path__ + "static/media/page-decoration-4.93a5de0a.svg";